import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export type PageContentProps = HTMLAttributes<HTMLDivElement>;

export const PageContent = ({
  children,
  className,
  ...props
}: PageContentProps) => {
  return (
    <div
      className={cn(
        'container mx-auto max-w-(--breakpoint-xl) px-4 py-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
